// extracted by mini-css-extract-plugin
export default {"tooltip":"KM-z","arrow":"LM-z"};